// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { createEntityAdapter } from '@reduxjs/toolkit';
import type {
  IlliquidAssetsClientEntity,
  IlliquidAssetsState,
} from '@shared/data-access/interfaces/redux/illiquid-assets-state-types';
import type { IlliquidAsset } from '@shared/data-access/types/engine-types';
import { isClientApp } from '@shared/environment';

export const illiquidAssetsClientAdapter = createEntityAdapter<
  IlliquidAssetsClientEntity,
  number
>({
  selectId: ({ id }) => id,
  sortComparer: (current, next) => current.id - next.id,
});

export const illiquidAssetsDataAdapter = createEntityAdapter<IlliquidAsset, number>(
  {
    selectId: ({ id }) => id,
    sortComparer: (current, next) => current.name.localeCompare(next.name),
  },
);

export const initialState: IlliquidAssetsState = {
  assets: illiquidAssetsClientAdapter.getInitialState(
    isClientApp
      ? {
          entities: {
            0: {
              id: 0,
              data: illiquidAssetsDataAdapter.getInitialState(),
            },
          },
          ids: [0],
        }
      : {},
  ),
};
